module.exports = __webpack_public_path__ + "img/uk.be9b75df.svg";